import faradayApi from "../../../api/faradayApi";

export const createLanding = async (htmlString) => {
  const endpoint = "/landing";

  const response = await faradayApi.post(endpoint, { htmlString });

  return response.data;
};

export const getLandingContent = async () => {
  const endpoint = "/landing";

  const response = await faradayApi.get(endpoint);

  return response.data;
};
